import { routes } from "consts";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useToaster } from "utils";
import { SurveyForm, SurveyFormValues } from "./SurveyForm";
import { HeaderWithBreadcrumbs, PageMain } from "components/molecules";
import { surveyApi } from "api/surveyApi";

export const SurveyCreatePage = () => {
  const navigate = useNavigate();
  const { showSuccess, showError } = useToaster();

  const breadcrumbs = [{ title: "Ankiety", path: routes.SURVEYS }, { title: "Dodawanie ankiety" }];

  const onSubmit = async (data: SurveyFormValues) => {
    try {
      await surveyApi.create(data);
      navigate(routes.SURVEYS);
      showSuccess("Ankieta została dodana.");
    } catch (e) {
      console.error(e);
      showError("Nie udało się dodać ankiety.");
    }
  };

  return (
    <PageMain>
      <HeaderWithBreadcrumbs breadcrumbs={breadcrumbs} headerText="Dodaj ankietę" />
      <SurveyForm onSubmit={onSubmit} />
    </PageMain>
  );
};
